/**
 * A skip rule resolved to this app's ids. The platform stores rules keyed by display
 * id and provider answer keys; the API resolves them before anything else sees them.
 */
export var SkipOperator;
(function (SkipOperator) {
    /** At least one of the listed options is selected ("equals" and "has one of"). */
    SkipOperator["AnyOf"] = "any_of";
    /** Any option is selected (a legacy empty answer list). */
    SkipOperator["AnyAnswer"] = "any_answer";
    /** A numeric text answer whose whole-number part is above zero (legacy). */
    SkipOperator["GreaterThanZero"] = "greater_than_zero";
})(SkipOperator || (SkipOperator = {}));
//# sourceMappingURL=types.js.map